import React from 'react';
import { QUIZ_TYPES } from '../constants/Quiz';
import {
  List,
  Datagrid,
  Edit,
  Create,
  SimpleForm,
  TextField,
  TextInput,
  EditButton,
  ReferenceArrayInput,
  SelectArrayInput,
  NumberInput,
  FileField,
  FileInput,
  ImageField,
  ArrayInput,
  SimpleFormIterator,
  ReferenceInput,
  SelectInput,
  BooleanField,
  BooleanInput,
  Filter,
  ArrayField,
  SingleFieldList,
  ChipField,
  required,
} from 'react-admin';

const TextFilter = (props) => (
  <Filter {...props}>
    <TextInput label="ID" source="id" alwaysOn />
    <SelectInput
      label="Төрөл"
      source="type"
      emptyText="Бүгд"
      choices={QUIZ_TYPES}
      alwaysOn
    />
    <ReferenceInput label="Хэл" source="lang" reference="languages" alwaysOn>
      <SelectInput optionText="name" optionValue="id" emptyText="Бүгд" />
    </ReferenceInput>
    <ReferenceArrayInput label="Түвшин" source="lvl" reference="languageLevels" fullWidth alwaysOn>
      <SelectArrayInput optionText="level" optionValue="id" emptyText="Бүгд" />
    </ReferenceArrayInput>
  </Filter>
);

export const QuizList = (props) => (
  <List {...props} filters={<TextFilter/>} >
    <Datagrid optimized>
      <TextField label="ID" source="id" />
      <TextField label="Төрөл" source="type" />
      <TextField label="Гарчиг" source="title" />
      <TextField label="Хэл" source="Languages.0.code" sortable={false} />
      <ArrayField label="Түвшин" source="LanguageLevels" sortable={false}>
        <SingleFieldList linkType={false}>
          <ChipField source="level" />
        </SingleFieldList>
      </ArrayField>
      <TextField label="Хугацаа" source="totalDuration" />
      <TextField label="Tag" source="languageTags" />
      <TextField label="Асуултын тоо" source="numberOfQuestion" />
      <BooleanField label="Үнэгүй үзэх" source="isPreview"/>
      <EditButton />
    </Datagrid>
  </List>
);

const QuizTitle = ({ record }) => {
  return (
    <span>
Quiz
      {record ? `"${record.title}"` : ''}
    </span>
  );
};

export const QuizEdit = (props) => (
  <Edit title={<QuizTitle />} {...props} transform={({ thumbnailImage, ...data }) => data}>
    <SimpleForm>
      <TextInput source="id" readOnly />
      <SelectInput source="type" choices={QUIZ_TYPES} />
      <BooleanInput label="Үнэгүй үзэж болох эсэх" source="isPreview" />
      <TextInput fullWidth label="Гарчиг" source="title" />
      <ReferenceInput label="Хэл" source="tagging.languageId" reference="languages">
        <SelectInput source="tagging.languageId" optionText="name" validate={[required()]} />
      </ReferenceInput>
      <ReferenceArrayInput source="tagging.countryIds" label="Харгалзах улсууд" reference="countries">
        <SelectArrayInput source="tagging.countryIds" optionText="name" validate={[required()]} />
      </ReferenceArrayInput>
      <ReferenceArrayInput  label="Хэлний түвшин" source="tagging.languageLevels" reference="languageLevels">
        <SelectArrayInput source="tagging.languageLevels" optionText="level" />
      </ReferenceArrayInput>
      <ReferenceArrayInput label="Tag" source="languageTags" reference="tags" perPage={500}>
        <SelectArrayInput source="languageTags" optionText="name" optionValue="name" />
      </ReferenceArrayInput>
      <TextInput label="Хугацаа" source="totalDuration" />
      <ReferenceInput fullWidth label="Бүлэг сонгох" source="bundleId" reference="quizBundles" perPage={200}>
        <SelectInput source="bundleId" optionText="title" optionValue="id"/>
      </ReferenceInput>
      <TextInput label="Дараалал" source="order" pattern="[0-9]{1,3}" />
      <ArrayInput fullWidth source="instructions">
        <SimpleFormIterator>
          <TextInput fullWidth source="value" label="Заавар" />
        </SimpleFormIterator>
      </ArrayInput>
      <ImageField source="thumbnailImage" title="Зураг" />
      <FileInput source="file" label="Зураг" accept="image/*">
        <FileField source="image" title="image" />
      </FileInput>
      <NumberInput label="Асуултын тоо" source="numberOfQuestion" />
      <SelectInput source="questionsThrough" label="Асуулт холбох" choices={[{id: 'tags', name: 'Хэл болон түвшингээр'}, {id:'quizId', name:'Тестийн ID-гаар'}]} helperText="Хэрвээ quizId-гаар татах бол харгалзал асуултууд орсон эсэхийг шалгаарай!" />
    </SimpleForm>
  </Edit>
);

export const QuizCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <SelectInput source="type" choices={QUIZ_TYPES} />
      <BooleanInput label="Үнэгүй үзэж болох эсэх" source="isPreview" />
      <TextInput fullWidth label="Гарчиг" source="title" />
      <ReferenceInput label="Хэл" source="tagging.languageId" reference="languages">
        <SelectInput source="tagging.languageId" optionText="name" validate={[required()]} />
      </ReferenceInput>
      <ReferenceArrayInput source="tagging.countryIds" label="Харгалзах улсууд" reference="countries">
        <SelectArrayInput source="tagging.countryIds" optionText="name" validate={[required()]} />
      </ReferenceArrayInput>
      <ReferenceArrayInput  label="Хэлний түвшин" source="tagging.languageLevels" reference="languageLevels">
        <SelectArrayInput source="tagging.languageLevels" optionText="level" />
      </ReferenceArrayInput>
      <ReferenceArrayInput label="Tag" source="languageTags" reference="tags" perPage={500}>
        <SelectArrayInput source="languageTags" optionText="name" optionValue="name" />
      </ReferenceArrayInput>
      <TextInput label="Хугацаа" source="totalDuration" />
      <ReferenceInput fullWidth label="Бүлэг сонгох" source="bundleId" reference="quizBundles" perPage={200}>
        <SelectInput source="bundleId" optionText="title" optionValue="id"/>
      </ReferenceInput>
      <TextInput label="Дараалал" source="order" pattern="[0-9]{1,3}" />
      <ArrayInput fullWidth source="instructions">
        <SimpleFormIterator>
          <TextInput fullWidth source="value" label="Заавар" />
        </SimpleFormIterator>
      </ArrayInput>
      <FileInput source="file" label="Зураг" accept="image/*">
        <FileField source="image" title="image" />
      </FileInput>
      <NumberInput label="Асуултын тоо" source="numberOfQuestion" />
      <SelectInput source="questionsThrough" label="Асуулт холбох" choices={[{id: 'tags', name: 'Хэл болон түвшингээр'}, {id:'quizId', name:'Тестийн ID-гаар'}]} helperText="Хэрвээ quizId-гаар татах бол харгалзал асуултууд орсон эсэхийг шалгаарай!" />
    </SimpleForm>
  </Create>
);
